module.exports = __webpack_public_path__ + "static/media/cert_20200202.e3f08c66.jpg";